import { SqlAggregateFunctionType } from '@models/helpers';

export interface DataListAggregateFormulaFieldModel {
  id: number;
  fieldId: number;
  operator: SqlAggregateFunctionType;
}
